var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7925 0.749456C17.0691 1.02608 17.0691 1.47457 16.7925 1.75119L10.0634 8.48035C9.78676 8.75696 9.33824 8.75696 9.06164 8.48035L6.02083 5.43955L1.2092 10.2512C0.932578 10.5278 0.484087 10.5278 0.207466 10.2512C-0.0691553 9.97458 -0.0691553 9.52607 0.207466 9.24946L5.51996 3.93696C5.79659 3.66034 6.24508 3.66034 6.5217 3.93696L9.5625 6.97777L15.7908 0.749456C16.0674 0.472838 16.5159 0.472838 16.7925 0.749456Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.332 1.25033C11.332 0.859127 11.6492 0.541992 12.0404 0.541992H16.2904C16.6816 0.541992 16.9987 0.859127 16.9987 1.25033V5.50033C16.9987 5.89154 16.6816 6.20866 16.2904 6.20866C15.8992 6.20866 15.582 5.89154 15.582 5.50033V1.95866H12.0404C11.6492 1.95866 11.332 1.64152 11.332 1.25033Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.653334b9959812360c3c28f1a1349981.svg";
export { ForwardRef as ReactComponent };